import React from 'react';
import type { ReactElement } from 'react';
import 'twin.macro';

import Heading from './Heading';

interface PageNavProps {
  previous?: ReactElement;
  next?: ReactElement;
}

const PageNav: React.FC<PageNavProps> = ({ previous, next }) => (
  <div tw="grid gap-12 my-12 lg:(grid-cols-2)">
    <div>
      {previous ? (
        <>
          <Heading level="h2" tw="text-4xl">Page précédente</Heading>
          {previous}
        </>
      ) : null}
    </div>
    <div>
      {next ? (
        <>
          <Heading level="h2" tw="text-4xl">Page suivante</Heading>
          {next}
        </>
      ) : null}
    </div>
  </div>
);

export default PageNav;
